export default "__VITE_ASSET__93e62b2e__"